/* LAND · 19-oct-2026 · Carrito (cajón): leyenda de envío y botón de pago. Va con az-carrito.css.
   - Leyenda de envío: texto fijo «Envío 1-2 días hábiles disponible», sin fechas (LAND 24-oct-2026, pedido de Carlos:
     «Llega entre el X y el Y de <mes>» confundía a las clientas). Igual que la ficha y la barra de anuncios.
   - «Pagar pedido»: el aviso de ropa interior (Selleasy) tarda 3–4 s en salir y mientras tanto el botón no hacía nada.
     Ahora el botón muestra que está cargando. Red de seguridad: si en 6 s no salió el aviso, no empezó a cargar el pago y
     la clienta no tocó nada más, la manda al pago de todos modos.
   - «Completa tu look» (app Hoppy): la app sugiere toda la joyería aunque la pieza ya esté en el carrito. Aquí se quitan
     del carrusel las que ya están; si la clienta las elimina del carrito, la app vuelve a pintar el carrusel y regresan.
   Para quitarlo: borrar la línea que carga este archivo en snippets/cart-drawer.liquid. */
(function () {
  /* LAND 24-oct-2026: sin fechas, texto fijo. */
  var TEXTO_ENVIO = 'Envío 1-2 días hábiles disponible';

  function ponerFecha() {
    var t = TEXTO_ENVIO;
    document.querySelectorAll('.az-cart-entrega__texto').forEach(function (el) {
      if (el.textContent !== t) el.textContent = t;
    });
  }

  /* ---- «Completa tu look»: no sugerir lo que ya está en el carrito ---- */
  var SUGERENCIAS = '#shipping-container-cart_drawer [futureblink-shipping-bar-swiper-container]';
  var limpieza = null, reintentos = 0;

  function handleDe(url) {
    var m = /\/products\/([^/?#]+)/.exec(url || '');
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  function quitarSugeridasEnCarrito() {
    var caja = document.querySelector(SUGERENCIAS);
    if (!caja) return;
    var sw = caja.querySelector('.swiper');
    var s = sw && sw.swiper;
    if (!s || s.destroyed || typeof s.removeSlide !== 'function') {
      // La app todavía no arma el carrusel: se vuelve a intentar en un momento.
      if (reintentos++ < 10) programarLimpieza(300);
      return;
    }
    reintentos = 0;
    var enCarrito = {};
    document.querySelectorAll('cart-drawer .cart-item__name').forEach(function (a) {
      var h = handleDe(a.getAttribute('href'));
      if (h) enCarrito[h] = true;
    });
    var quitar = [], quedan = 0;
    Array.prototype.forEach.call(s.slides, function (slide, i) {
      if (slide.classList.contains('swiper-slide-duplicate')) return;
      var a = slide.querySelector('a[href*="/products/"]');
      var h = a && handleDe(a.getAttribute('href'));
      if (h && enCarrito[h]) {
        // Con «loop», Swiper quita por el orden original de las tarjetas (data-swiper-slide-index).
        var real = slide.getAttribute('data-swiper-slide-index');
        quitar.push(s.params.loop && real !== null ? parseInt(real, 10) : i);
      } else {
        quedan++;
      }
    });
    if (!quitar.length) return;
    if (!quedan) { caja.classList.add('az-sin-sugerencias'); return; }
    s.removeSlide(quitar);
  }

  function programarLimpieza(ms) {
    if (limpieza) return;
    limpieza = setTimeout(function () {
      limpieza = null;
      try { quitarSugeridasEnCarrito(); } catch (e) { /* si la app cambia, el carrito sigue funcionando igual */ }
    }, ms || 80);
  }

  function alCambiarCajon() {
    ponerFecha();
    programarLimpieza();
  }

  function iniciar() {
    ponerFecha();
    programarLimpieza();
    var cajon = document.querySelector('cart-drawer');
    if (cajon) new MutationObserver(alCambiarCajon).observe(cajon, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  /* ---- «Pagar pedido» ---- */
  var ESPERA = 6000;
  var espera = null;
  var BOTONES = '#CartDrawer-Checkout, #checkout';

  function avisoVisible() {
    var p = document.getElementById('lb-addon-popup-container-id') || document.querySelector('[class*="lb-addon-popup-container"]');
    if (!p) return false;
    var s = getComputedStyle(p), r = p.getBoundingClientRect();
    return s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity) > 0.1 && r.width > 50 && r.height > 50;
  }

  function terminar() {
    if (espera) { clearInterval(espera); espera = null; }
    document.querySelectorAll('.az-cargando').forEach(function (b) { b.classList.remove('az-cargando'); });
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest(BOTONES);
    if (!boton || boton.disabled || espera) return;
    boton.classList.add('az-cargando');
    var inicio = Date.now();
    espera = setInterval(function () {
      if (avisoVisible()) { terminar(); return; }
      if (Date.now() - inicio > ESPERA) {
        clearInterval(espera);
        espera = null;
        window.location.href = '/checkout';
      }
    }, 150);
  }, true);

  // Si toca otra cosa mientras espera (cerrar, cambiar cantidad…), no se le manda al pago sola.
  document.addEventListener('pointerdown', function (e) {
    if (!espera) return;
    if (e.target.closest && e.target.closest(BOTONES)) return;
    terminar();
  }, true);

  // Ya va al pago: se deja el botón cargando y se apaga la espera.
  window.addEventListener('beforeunload', function () {
    if (espera) { clearInterval(espera); espera = null; }
  });

  // Al regresar con «atrás», el botón vuelve a la normalidad.
  window.addEventListener('pageshow', terminar);
})();

/* LAND · 22-oct-2026 · Código de descuento en el carrito (pedido de Carlos). Va con el bloque «az-descuento» de
   snippets/cart-drawer.liquid y sus estilos en az-carrito.css.
   - Usa la API del carrito de Shopify: /cart/update.js con «discount» (los códigos separados por coma).
   - Si el código no existe o no aplica, Shopify lo regresa con applicable:false: se quita y se avisa.
   - Después vuelve a pintar el carrito con lo que ya trae el tema (cart-drawer-items → onCartUpdate), así el total
     y los descuentos salen ya calculados por Shopify. La caja de descuento del pago sigue igual. */
(function () {
  var mensajePendiente = null;

  function rutaActualizar() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update';
  }

  function pedirCarrito() {
    return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function codigosQueAplican(carrito) {
    return (carrito.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }

  function mandarCodigos(codigos) {
    return fetch(rutaActualizar(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codigos.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function escribirMensaje(texto, esError) {
    document.querySelectorAll('[data-az-descuento-mensaje]').forEach(function (el) {
      el.textContent = texto || '';
      el.classList.toggle('az-error', !!esError);
    });
  }

  function cargando(si) {
    document.querySelectorAll('[data-az-descuento]').forEach(function (el) { el.classList.toggle('az-descuento--cargando', si); });
  }

  function repintar() {
    var items = document.querySelector('cart-drawer-items');
    var listo = items && typeof items.onCartUpdate === 'function' ? items.onCartUpdate() : Promise.resolve();
    return Promise.resolve(listo).then(function () {
      // El pie del carrito se reemplaza: se vuelve a poner el mensaje en el nuevo.
      if (mensajePendiente) {
        escribirMensaje(mensajePendiente.texto, mensajePendiente.error);
        // Si el código no sirvió, se deja escrito para que la clienta lo corrija.
        if (mensajePendiente.valor) document.querySelectorAll('cart-drawer input[name="az_codigo"]').forEach(function (i) { i.value = mensajePendiente.valor; });
        mensajePendiente = null;
      }
    });
  }

  function igual(a, b) { return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase(); }

  function aplicar(codigo) {
    codigo = String(codigo || '').trim();
    if (!codigo) { escribirMensaje('Escribe tu código de descuento.', true); return; }
    cargando(true);
    escribirMensaje('Aplicando…', false);
    var antes = [];
    pedirCarrito()
      .then(function (carrito) {
        antes = codigosQueAplican(carrito);
        if (antes.some(function (c) { return igual(c, codigo); })) return { yaEstaba: true };
        return mandarCodigos(antes.concat([codigo]));
      })
      .then(function (carrito) {
        if (carrito.yaEstaba) { mensajePendiente = { texto: 'El código «' + codigo.toUpperCase() + '» ya está aplicado.', error: false }; return; }
        var dato = (carrito.discount_codes || []).filter(function (d) { return igual(d.code, codigo); })[0];
        if (dato && dato.applicable) {
          mensajePendiente = { texto: 'Código «' + dato.code.toUpperCase() + '» aplicado.', error: false };
          return;
        }
        mensajePendiente = { texto: 'El código «' + codigo.toUpperCase() + '» no es válido o no aplica a tu carrito.', error: true, valor: codigo };
        // Se deja el carrito como estaba (sin el código que no aplica).
        return mandarCodigos(antes);
      })
      .then(repintar)
      .catch(function () {
        mensajePendiente = null;
        escribirMensaje('No se pudo aplicar el código. Inténtalo de nuevo o escríbelo en la pantalla de pago.', true);
      })
      .then(function () { cargando(false); });
  }

  function quitar(codigo) {
    cargando(true);
    pedirCarrito()
      .then(function (carrito) {
        var quedan = codigosQueAplican(carrito).filter(function (c) { return !igual(c, codigo); });
        return mandarCodigos(quedan);
      })
      .then(function () {
        mensajePendiente = { texto: 'Se quitó el código «' + String(codigo).toUpperCase() + '».', error: false };
        return repintar();
      })
      .catch(function () { escribirMensaje('No se pudo quitar el código. Inténtalo de nuevo.', true); })
      .then(function () { cargando(false); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-az-descuento-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var input = form.querySelector('input[name="az_codigo"]');
    aplicar(input && input.value);
  }, true);

  document.addEventListener('click', function (e) {
    var boton = e.target && e.target.closest && e.target.closest('[data-az-quitar-codigo]');
    if (!boton) return;
    e.preventDefault();
    e.stopPropagation();
    quitar(boton.getAttribute('data-az-quitar-codigo'));
  }, true);
})();
